export default __webpack_public_path__ + "static/media/app_store.776424e4.png";